import React from 'react';
import { Dashboard } from './dashboard.jsx';
import { buildMockTenantDomain } from './data.jsx';
import { FEATURED_TENANTS } from './extended-mock-data.jsx';
import { Icon } from './icons.jsx';
import { FEATURE_REPAIRS_MODULE, USE_REAL_REPAIRS_API, saIsRealRepairsMode } from './mvp-config.jsx';
import { formatRepairError, repairService, useTenants } from './services.jsx';
// Repairs & Suporte — diagnóstico, repairs e playbooks
const { useState, useEffect } = React;

const REPAIR_CATEGORIES = [
  {
    name: 'Provisionamento', icon: 'package',
    repairs: [
      { id: 'rep_01', name: 'Recriar TenantMapping',             desc: 'Recria o mapeamento entre usuário e tenant no schema público.',       risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_02', name: 'Recriar StaffUserProfile do owner',  desc: 'Recria o perfil de staff do proprietário com role Gerente.',           risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_03', name: 'Recriar role Gerente',               desc: 'Cria a role padrão de gerente com todas as permissões do plano.',      risk: 'baixo', reversible: true,  requiresReason: true },
      { id: 'rep_04', name: 'Recriar Site',                       desc: 'Recria o registro de Site do Django associado ao domínio do tenant.',  risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_05', name: 'Recriar StoreSettings vazio',        desc: 'Cria configurações padrão da loja sem sobrescrever dados existentes.', risk: 'baixo', reversible: true,  requiresReason: true },
      { id: 'rep_06', name: 'Recriar centro de distribuição',      desc: 'Cria o centro de distribuição padrão com endereço vazio.',            risk: 'baixo', reversible: true,  requiresReason: true },
      { id: 'rep_07', name: 'Recriar Product Classes padrão',     desc: 'Recria as classes de produto padrão do catálogo.',                    risk: 'baixo', reversible: true,  requiresReason: true },
      { id: 'rep_08', name: 'Reaplicar tema padrão',              desc: 'Aplica o tema padrão do sistema sem remover personalizações.',        risk: 'baixo', reversible: true,  requiresReason: true },
    ],
  },
  {
    name: 'Permissões', icon: 'shield',
    repairs: [
      { id: 'rep_10', name: 'Sincronizar permissões com plano',   desc: 'Garante que as roles do tenant estejam alinhadas com o plano atual.', risk: 'baixo', reversible: true,  requiresReason: true },
      { id: 'rep_11', name: 'Atualizar schema_version das roles', desc: 'Atualiza o campo schema_version de todas as roles para a versão atual.',risk:'baixo',reversible: true,  requiresReason: true },
      { id: 'rep_12', name: 'Remover rotas restritas pós-downgrade',desc:'Remove rotas do plano superior após downgrade de plano.',            risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_13', name: 'Restaurar permissões do gerente',    desc: 'Restaura todas as permissões padrão da role Gerente.',               risk: 'medio', reversible: false, requiresReason: true },
    ],
  },
  {
    name: 'Domínios', icon: 'globe',
    repairs: [
      { id: 'rep_20', name: 'Validar domínio primário',            desc: 'Verifica DNS, SSL e acessibilidade do domínio principal.',           risk: 'baixo', reversible: true,  requiresReason: false },
      { id: 'rep_21', name: 'Recriar domínio principal',           desc: 'Recria o registro de domínio associado ao tenant.',                  risk: 'alto',  reversible: false, requiresReason: true },
      { id: 'rep_22', name: 'Atualizar Site.domain',               desc: 'Atualiza o domínio registrado no objeto Site do Django.',            risk: 'medio', reversible: true,  requiresReason: true },
    ],
  },
  {
    name: 'Busca e Cache', icon: 'search',
    repairs: [
      { id: 'rep_30', name: 'Reindexar busca do tenant',           desc: 'Reindexar todos os produtos do tenant no OpenSearch.',               risk: 'baixo', reversible: true,  requiresReason: false },
      { id: 'rep_31', name: 'Recriar índice do tenant',            desc: 'Apaga e recria o índice do OpenSearch para o tenant.',               risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_32', name: 'Limpar cache do tenant',              desc: 'Limpa todas as chaves Redis associadas ao schema do tenant.',        risk: 'baixo', reversible: false, requiresReason: false },
      { id: 'rep_33', name: 'Aquecer cache',                       desc: 'Pré-popula o cache com dados críticos do tenant.',                   risk: 'baixo', reversible: true,  requiresReason: false },
    ],
  },
  {
    name: 'Integrações', icon: 'link',
    repairs: [
      { id: 'rep_40', name: 'Rotacionar token público',            desc: 'Gera novo token e invalida o anterior com segurança.',               risk: 'medio', reversible: false, requiresReason: true },
      { id: 'rep_41', name: 'Revogar token suspeito',              desc: 'Revoga imediatamente o token e registra na auditoria.',              risk: 'alto',  reversible: false, requiresReason: true },
      { id: 'rep_42', name: 'Reprocessar sync de app',             desc: 'Reprocessa a última sincronização do app de integração.',            risk: 'baixo', reversible: true,  requiresReason: false },
    ],
  },
  {
    name: 'Storage', icon: 'package',
    repairs: [
      { id: 'rep_50', name: 'Validar bucket/path do tenant',       desc: 'Verifica existência e permissões do bucket R2 do tenant.',           risk: 'baixo', reversible: true,  requiresReason: false },
      { id: 'rep_51', name: 'Encontrar arquivos órfãos',           desc: 'Lista arquivos sem referência no banco do tenant.',                  risk: 'baixo', reversible: true,  requiresReason: false },
      { id: 'rep_52', name: 'Corrigir URLs públicas',              desc: 'Atualiza URLs de imagem quebradas nos produtos do tenant.',          risk: 'medio', reversible: true,  requiresReason: true },
    ],
  },
];

const DIAG_CHECKS = [
  { id: 'tenant',      label: 'Tenant existe',                  repairId: null },
  { id: 'schema',      label: 'Schema existe',                  repairId: null },
  { id: 'domain',      label: 'Domain existe',                  repairId: 'rep_20' },
  { id: 'mapping',     label: 'TenantMapping existe',           repairId: 'rep_01' },
  { id: 'owner',       label: 'Owner existe',                   repairId: null },
  { id: 'staff',       label: 'StaffUserProfile existe',        repairId: 'rep_02' },
  { id: 'role',        label: 'Role Gerente existe',            repairId: 'rep_03' },
  { id: 'permissions', label: 'Permissões compatíveis com plano',repairId: 'rep_10' },
  { id: 'site',        label: 'Site configurado',               repairId: 'rep_04' },
  { id: 'settings',    label: 'StoreSettings existe',           repairId: 'rep_05' },
  { id: 'partner',     label: 'Partner existe',                 repairId: 'rep_06' },
  { id: 'partneraddr', label: 'PartnerAddress existe',          repairId: 'rep_06' },
  { id: 'product_class',label:'Product Classes existem',        repairId: 'rep_07' },
  { id: 'theme',       label: 'Tema aplicado',                  repairId: 'rep_08' },
  { id: 'search',      label: 'Busca indexada',                 repairId: 'rep_30' },
  { id: 'cache',       label: 'Cache OK',                       repairId: 'rep_32' },
  { id: 'storage',     label: 'Storage OK',                     repairId: 'rep_50' },
  { id: 'tokens',      label: 'Tokens OK',                      repairId: null },
];

const HISTORY_MOCK = [
  { ts: 'Hoje, 11:30',   tenant: 'Moda Clara',           repair: 'Recriar StoreSettings vazio',by:'Pedro Chaves',  result:'parcial',duration:'2.4s', reason:'Falha de provisionamento detectada',changed:['store_settings'] },
  { ts: 'Ontem, 15:00', tenant: 'Tech Store Brasil',    repair: 'Limpar cache do tenant',      by:'Beatriz Lima',  result:'success',duration:'0.3s', reason:'Produto desaparecendo após edição',  changed:['redis:tech_store_brasil:*'] },
  { ts: '22 Mai, 10:00',tenant: 'Loja Exemplo Premium', repair: 'Reindexar busca do tenant',   by:'Rafael Tavares',result:'success',duration:'14.2s',reason:'Índice desatualizado após importação',changed:['opensearch:loja42'] },
  { ts: '21 Mai, 16:30',tenant: 'Moda Clara',           repair: 'Recriar role Gerente',        by:'Ana Vargas',    result:'success',duration:'0.8s', reason:'Owner não conseguia acessar painel', changed:['role:gerente'] },
  { ts: '20 Mai, 14:00',tenant: 'Tech Store Brasil',    repair: 'Validar domínio primário',     by:'Beatriz Lima',  result:'success',duration:'1.1s', reason:'—',                                 changed:[] },
];

const PLAYBOOKS = [
  { symptom: 'Tenant criado mas dashboard não abre',    diag:'Completo',       repairs:['rep_04','rep_01','rep_05'],risk:'medio',steps:['Verificar Site','Verificar TenantMapping','Verificar StoreSettings'] },
  { symptom: 'Owner não consegue logar',               diag:'Usuários',       repairs:['rep_02','rep_03','rep_13'],risk:'medio',steps:['Verificar StaffUserProfile','Verificar role Gerente','Restaurar permissões'] },
  { symptom: 'Domínio customizado não funciona',       diag:'Domínios',       repairs:['rep_20','rep_21','rep_22'],risk:'alto', steps:['Validar DNS','Verificar Site.domain','Recriar domínio se necessário'] },
  { symptom: 'Plano alterado mas permissões não mudaram',diag:'Permissões',   repairs:['rep_10','rep_11'],         risk:'baixo',steps:['Sincronizar permissões com plano','Atualizar schema_version'] },
  { symptom: 'Busca não retorna produtos',             diag:'Busca',          repairs:['rep_30','rep_31'],         risk:'baixo',steps:['Reindexar tenant','Recriar índice se vazio'] },
  { symptom: 'Integração retornando 401',              diag:'Integrações',    repairs:['rep_40','rep_42'],         risk:'medio',steps:['Rotacionar token público','Reprocessar sync de app'] },
  { symptom: 'Storage com imagens quebradas',          diag:'Storage',        repairs:['rep_50','rep_52'],         risk:'baixo',steps:['Validar bucket','Corrigir URLs públicas'] },
  { symptom: 'Provisionamento falhou parcialmente',    diag:'Provisionamento',repairs:['rep_01','rep_02','rep_05'],risk:'alto', steps:['Executar diagnóstico completo','Reparar itens com falha um a um'] },
];

const RISK_CONFIG = {
  baixo: { label: 'Baixo', bg: 'var(--success-bg)', color: 'var(--success)' },
  medio: { label: 'Médio', bg: 'var(--warning-bg)', color: 'var(--warning)' },
  alto:  { label: 'Alto',  bg: 'var(--danger-bg)',  color: 'var(--danger)'  },
};

const RiskBadge = ({ risk }) => {
  const c = RISK_CONFIG[risk] || RISK_CONFIG.baixo;
  return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 8px', borderRadius: 20, background: c.bg, color: c.color, fontSize: 11, fontWeight: 600 }}>
    <span style={{ width: 5, height: 5, borderRadius: '50%', background: c.color }} />{c.label}
  </span>;
};

// ── Repair Confirm Modal ──────────────────────────────────────────────────────
const RepairConfirmModal = ({ open, repair, tenant, onClose, onConfirm, logAction }) => {
  const [motivo,     setMotivo]     = useState('');
  const [understand, setUnderstand] = useState(false);
  const [audit,      setAudit]      = useState(true);
  const [running,    setRunning]    = useState(false);
  const [result,     setResult]     = useState(null);

  const reset = () => { setMotivo(''); setUnderstand(false); setResult(null); setRunning(false); };

  if (!open || !repair) return null;
  const rc = RISK_CONFIG[repair.risk] || RISK_CONFIG.baixo;

  const handleRun = () => {
    if (!motivo.trim() || !understand) return;
    setRunning(true);
    setTimeout(() => {
      const ok = Math.random() > 0.15;
      const partial = !ok && Math.random() > 0.5;
      setRunning(false);
      setResult(ok ? 'success' : partial ? 'parcial' : 'falha');
      if (logAction) logAction({ acao: `Repair: ${repair.name} · motivo: ${motivo}`, loja: tenant?.name || '—', lojaId: tenant?.id, kind: ok ? 'info' : 'danger' });
      if (onConfirm) onConfirm({ repair, tenant, ok, partial });
    }, 1800 + Math.random() * 1200);
  };

  return (
    <div onClick={result ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 520, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <div style={{ width: 38, height: 38, borderRadius: 8, background: rc.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="wrench" size={18} style={{ color: rc.color }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{repair.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{tenant?.name || 'Tenant não selecionado'}</div>
          </div>
          {!result && !running && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>

        <div style={{ padding: '16px 22px' }}>
          {!result && !running && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
                <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Risco</div>
                  <RiskBadge risk={repair.risk} />
                </div>
                <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Reversível</div>
                  <span className={`badge ${repair.reversible ? 'success' : 'danger'}`}><span className="dot" />{repair.reversible ? 'Sim' : 'Não'}</span>
                </div>
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 14, lineHeight: 1.5 }}>{repair.desc}</div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo <span style={{ color: 'var(--danger)' }}>*</span></label>
                <textarea value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Descreva o motivo técnico ou comercial deste repair…" style={{ width: '100%', height: 72, padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'none' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={understand} onChange={e => setUnderstand(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 14, height: 14 }} />
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Entendo o impacto e os riscos desta operação{!repair.reversible ? ' irreversível' : ''}.</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={audit} onChange={e => setAudit(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 14, height: 14 }} />
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Registrar na auditoria (obrigatório para risco médio/alto).</span>
                </label>
              </div>
            </>
          )}
          {running && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600, fontSize: 15 }}>Executando repair…</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>{repair.name}</div>
            </div>
          )}
          {result && (
            <div>
              <div style={{ textAlign: 'center', padding: '16px 0 20px' }}>
                <div style={{ width: 56, height: 56, borderRadius: '50%', background: result==='success'?'var(--success-bg)':result==='parcial'?'var(--warning-bg)':'var(--danger-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
                  <Icon name={result==='success'?'check':result==='parcial'?'alert':'x'} size={24} style={{ color: result==='success'?'var(--success)':result==='parcial'?'var(--warning)':'var(--danger)' }} />
                </div>
                <div style={{ fontWeight: 700, fontSize: 16 }}>{result==='success'?'Repair concluído com sucesso':result==='parcial'?'Concluído parcialmente':'Repair falhou'}</div>
                <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>{result==='success'?'Todas as operações foram executadas.':result==='parcial'?'Algumas operações falharam. Verifique os logs.':'Verifique os logs e tente novamente.'}</div>
              </div>
              {result !== 'success' && (
                <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>
                  Error: Operation partially failed · check audit log for details
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {!result && !running && (
            <>
              <button className="btn" onClick={onClose}>Cancelar</button>
              <button className={`btn ${repair.risk === 'alto' ? 'danger' : 'primary'}`} disabled={!motivo.trim() || !understand} onClick={handleRun}>
                <Icon name="wrench" size={14} />Executar repair
              </button>
            </>
          )}
          {result && (
            <>
              <button className="btn" onClick={() => { reset(); onClose(); }}>Fechar</button>
              {result !== 'success' && <button className="btn primary" onClick={() => reset()}>Tentar novamente</button>}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ── Repair Confirm Modal (API Fase 8) ─────────────────────────────────────────
const ApiRepairConfirmModal = ({ open, action, tenant, onClose, onConfirm, onToast }) => {
  const [motivo, setMotivo] = useState('');
  const [understand, setUnderstand] = useState(false);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [resultMessage, setResultMessage] = useState('');

  const reset = () => { setMotivo(''); setUnderstand(false); setResult(null); setResultMessage(''); setRunning(false); };

  if (!open || !action || !tenant) return null;
  const needsReason = !!action.requires_reason;
  const severity = action.severity || 'safe';
  const rc = RISK_CONFIG[severity === 'safe' ? 'baixo' : 'medio'] || RISK_CONFIG.baixo;

  const handleRun = async () => {
    if (needsReason && !motivo.trim()) return;
    if (!understand) return;
    setRunning(true);
    try {
      const response = await repairService.runRepair(tenant.id, {
        action: action.action,
        reason: needsReason ? motivo.trim() : (motivo.trim() || undefined),
      });
      const ok = response.status === 'success' || (response.status !== 'failed' && response.status !== 'not_available');
      setResult(ok ? 'success' : response.status === 'not_available' ? 'parcial' : 'falha');
      setResultMessage(response.message || '');
      if (onConfirm) onConfirm({ action, tenant, ok, response });
      if (onToast) onToast(response.message || (ok ? 'Repair concluído' : 'Repair não disponível'));
    } catch (e) {
      setResult('falha');
      setResultMessage(typeof formatRepairError !== 'undefined' ? formatRepairError(e) : (e?.message || 'Erro'));
      if (onToast) onToast(typeof formatRepairError !== 'undefined' ? formatRepairError(e) : 'Erro ao executar repair');
    } finally {
      setRunning(false);
    }
  };

  return (
    <div onClick={result ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 520, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <div style={{ width: 38, height: 38, borderRadius: 8, background: rc.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="wrench" size={18} style={{ color: rc.color }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{action.label}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{tenant.name} · {action.action}</div>
          </div>
          {!result && !running && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>
        <div style={{ padding: '16px 22px' }}>
          {!result && !running && (
            <>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 14, lineHeight: 1.5 }}>
                Ação allowlisted do Super Admin. Será registrada na auditoria.
              </div>
              {needsReason && (
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo <span style={{ color: 'var(--danger)' }}>*</span></label>
                  <textarea value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Descreva o motivo deste repair…" style={{ width: '100%', height: 72, padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'none' }} />
                </div>
              )}
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
                <input type="checkbox" checked={understand} onChange={e => setUnderstand(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 14, height: 14 }} />
                <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Confirmo a execução desta ação no tenant selecionado.</span>
              </label>
            </>
          )}
          {running && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600, fontSize: 15 }}>Executando…</div>
            </div>
          )}
          {result && (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{result === 'success' ? 'Concluído' : result === 'parcial' ? 'Indisponível' : 'Falhou'}</div>
              {resultMessage && <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8 }}>{resultMessage}</div>}
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {!result && !running && (
            <>
              <button className="btn" onClick={onClose}>Cancelar</button>
              <button className="btn primary" disabled={(needsReason && !motivo.trim()) || !understand} onClick={handleRun}>
                <Icon name="wrench" size={14} />Executar
              </button>
            </>
          )}
          {result && <button className="btn primary" onClick={() => { reset(); onClose(); }}>Fechar</button>}
        </div>
      </div>
    </div>
  );
};

const mapApiCheckStatus = (status) => ({ ok: 'ok', warning: 'aviso', error: 'falha', unknown: 'aviso' }[status] || 'aviso');

const storeToRepairTenant = (store) => {
  if (!store) return null;
  const tid = store.tenant_id ?? String(store.id || '').replace(/^tenant_/, '');
  return {
    id: tid,
    tenant_id: tid,
    name: store.name,
    schema: store.schema_name,
    schema_name: store.schema_name,
    domain: store.domain,
    status: store.status,
    plan: store.plan?.name || store.plan?.id || store.plan || 'basic',
    commercial_status: store.commercial_status || store.status,
  };
};

// ── Export Diag Modal ─────────────────────────────────────────────────────────
const ExportDiagModal = ({ open, onClose, onToast, logAction, contextTicket, selectedTenantName }) => {
  const [tenantScope, setTenantScope] = useState('selected');
  const [content,     setContent]     = useState(['diag','history','logs']);
  const [period,      setPeriod]      = useState('24h');
  const [format,      setFormat]      = useState('PDF');
  const [inclTicket,  setInclTicket]  = useState(true);
  const [running,     setRunning]     = useState(false);
  const [done,        setDone]        = useState(false);

  if (!open) return null;

  const toggleContent = v => setContent(s => s.includes(v) ? s.filter(x => x !== v) : [...s, v]);

  const handleExport = () => {
    setRunning(true);
    setTimeout(() => {
      setRunning(false);
      setDone(true);
      logAction && logAction({ acao: `Diagnóstico exportado (${format}) · ${selectedTenantName || 'todos'}`, loja: selectedTenantName || '—', kind: 'info' });
    }, 2200);
  };

  const handleClose = () => {
    setTenantScope('selected'); setContent(['diag','history','logs']); setPeriod('24h'); setFormat('PDF');
    setInclTicket(true); setRunning(false); setDone(false);
    onClose();
  };

  return (
    <div onClick={done ? undefined : handleClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="download" size={17} style={{ color: 'var(--info)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Exportar diagnóstico</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Configure o relatório de diagnóstico</div>
          </div>
          {!running && !done && <button className="icon-action" onClick={handleClose}><Icon name="x" size={16} /></button>}
        </div>

        <div style={{ padding: '16px 22px' }}>
          {!running && !done && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Tenant</label>
                <div style={{ display: 'flex', gap: 4 }}>
                  {[['selected', selectedTenantName ? `Tenant selecionado (${selectedTenantName})` : 'Tenant selecionado'],['all','Todos os tenants']].map(([v,l]) => (
                    <button key={v} onClick={() => setTenantScope(v)} style={{ flex: 1, padding: '6px 10px', borderRadius: 6, border: '1px solid', borderColor: tenantScope===v?'var(--brand-navy)':'var(--border)', background: tenantScope===v?'var(--brand-navy)':'transparent', color: tenantScope===v?'white':'var(--text-secondary)', fontSize: 12, fontWeight: 500, cursor: 'pointer', transition: 'all 120ms' }}>{l}</button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Conteúdo</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                  {[['diag','Diagnóstico atual'],['history','Histórico de repairs'],['logs','Logs recentes'],['playbooks','Playbooks executados'],['jobs','Jobs/reprocessamentos']].map(([v,l]) => (
                    <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', padding: '6px 10px', borderRadius: 6, border: '1px solid', borderColor: content.includes(v)?'var(--brand-navy)':'var(--border)', background: content.includes(v)?'color-mix(in srgb, var(--brand-navy) 8%, transparent)':'transparent', transition: 'all 120ms' }}>
                      <input type="checkbox" checked={content.includes(v)} onChange={() => toggleContent(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                      <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{l}</span>
                    </label>
                  ))}
                </div>
              </div>
              {/* Ticket context if available */}
              {contextTicket && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '8px 12px', borderRadius: 8, border: '1px solid', borderColor: inclTicket ? 'var(--info)' : 'var(--border)', background: inclTicket ? 'var(--info-bg)' : 'transparent', transition: 'all 120ms' }}>
                  <input type="checkbox" checked={inclTicket} onChange={e => setInclTicket(e.target.checked)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>Incluir contexto do ticket</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>Ticket {contextTicket.id} — {contextTicket.subject}</div>
                  </div>
                </label>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Período</label>
                  <select className="select" style={{ width: '100%' }} value={period} onChange={e => setPeriod(e.target.value)}>
                    <option value="24h">Últimas 24h</option>
                    <option value="7d">Últimos 7 dias</option>
                    <option value="30d">Últimos 30 dias</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Formato</label>
                  <div style={{ display: 'flex', gap: 4 }}>
                    {['PDF','CSV','JSON'].map(f => (
                      <button key={f} onClick={() => setFormat(f)} style={{ flex: 1, padding: '5px 0', borderRadius: 6, border: '1px solid', borderColor: format===f?'var(--brand-navy)':'var(--border)', background: format===f?'var(--brand-navy)':'transparent', color: format===f?'white':'var(--text-secondary)', fontSize: 11, fontWeight: 600, cursor: 'pointer', transition: 'all 120ms' }}>{f}</button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {running && (
            <div style={{ textAlign: 'center', padding: '28px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Gerando relatório de diagnóstico…</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>Coletando dados do tenant</div>
            </div>
          )}

          {done && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <Icon name="check" size={22} style={{ color: 'var(--success)' }} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Relatório de diagnóstico gerado</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
                {format} · {tenantScope === 'selected' ? (selectedTenantName || 'tenant selecionado') : 'todos os tenants'} · Última exportação: agora
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {!done && !running && (
            <>
              <button className="btn" onClick={handleClose}>Cancelar</button>
              <button className="btn primary" onClick={handleExport}><Icon name="download" size={14} />Exportar diagnóstico</button>
            </>
          )}
          {done && <button className="btn primary" onClick={handleClose}><Icon name="check" size={14} />Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Reexecutar Item do Histórico ─────────────────────────────────────────
const ReexecuteHistoryModal = ({ open, item, onClose, onConfirm }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open || !item) return null;

  const handleConfirm = () => {
    setStep(1);
    setTimeout(() => { const ok = Math.random() > 0.15; setStep(ok ? 2 : 3); onConfirm && onConfirm({ item, ok }); }, 2400);
  };

  return (
    <div onClick={step === 1 ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'center' }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="refresh" size={17} style={{ color: 'var(--warning)' }} /></div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Reexecutar repair</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{item.repair} · {item.tenant}</div>
          </div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>
        <div style={{ padding: '18px 22px' }}>
          {step === 0 && (
            <>
              <div style={{ padding: '10px 12px', background: 'var(--warning-bg)', borderRadius: 8, fontSize: 13, color: 'var(--warning)', marginBottom: 16, display: 'flex', gap: 8 }}>
                <Icon name="alert" size={13} style={{ flexShrink: 0, marginTop: 1 }} />
                Uma nova execução será adicionada ao histórico. A ação original pode ter deixado dados alterados.
              </div>
              {[['Ação original', item.repair], ['Tenant', item.tenant], ['Executado em', item.ts], ['Responsável', item.by], ['Resultado ant.', item.result], ['Motivo original', item.reason]].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{k}</span>
                  <span style={{ fontWeight: 500, maxWidth: 280, textAlign: 'right' }}>{v}</span>
                </div>
              ))}
            </>
          )}
          {step === 1 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Executando…</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>{item.repair}</div>
            </div>
          )}
          {step === 2 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="check" size={22} style={{ color: 'var(--success)' }} /></div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Reexecução concluída</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>Novo registro adicionado ao histórico.</div>
            </div>
          )}
          {step === 3 && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--danger-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="x" size={22} style={{ color: 'var(--danger)' }} /></div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Reexecução falhou</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>Verifique os logs e tente novamente.</div>
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {step === 0 && <><button className="btn" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleConfirm}><Icon name="refresh" size={13} />Reexecutar</button></>}
          {(step === 2 || step === 3) && <button className="btn primary" onClick={onClose}>Fechar</button>}
        </div>
      </div>
    </div>
  );
};

// ── Drawer: Iniciar Playbook ─────────────────────────────────────────────────────
const PlaybookExecutionModal = ({ open, playbook, tenant, onClose, onConfirm }) => {
  const [phase,     setPhase]     = useState('config');
  const [stepIndex, setStepIndex] = useState(-1);
  const [doneSteps, setDoneSteps] = useState([]);

  React.useEffect(() => { if (!open) { setPhase('config'); setStepIndex(-1); setDoneSteps([]); } }, [open]);
  if (!open || !playbook) return null;

  const steps = playbook.steps || [];

  const handleStart = () => {
    setPhase('running');
    setStepIndex(0);
    setDoneSteps([]);
    const runStep = (i) => {
      setStepIndex(i);
      setTimeout(() => {
        setDoneSteps(d => [...d, i]);
        if (i < steps.length - 1) { setTimeout(() => runStep(i + 1), 300); }
        else { setTimeout(() => { setPhase('done'); onConfirm && onConfirm({ playbook, tenant }); }, 500); }
      }, 900 + Math.random() * 600);
    };
    runStep(0);
  };

  return (
    <div onClick={phase === 'running' ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 520, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="list" size={16} style={{ color: 'var(--info)' }} /></div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Playbook</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{playbook.symptom}</div>
          </div>
          {phase !== 'running' && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 18 }}>
          {phase === 'done' && (
            <div style={{ padding: '10px 14px', background: 'var(--success-bg)', borderRadius: 8, fontSize: 13, color: 'var(--success)', display: 'flex', gap: 8, alignItems: 'center' }}>
              <Icon name="check" size={14} />Playbook executado · Adicionado ao histórico
            </div>
          )}
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Informações</div>
            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
              {[['Sintoma', playbook.symptom], ['Diagnóstico', playbook.diag], ['Risco', <RiskBadge risk={playbook.risk} />], ['Tenant', tenant?.name || 'Não selecionado'], ['Repairs', `${playbook.repairs?.length || 0} ações`]].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                  <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{k}</span>
                  <span style={{ fontWeight: 500 }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Etapas</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {steps.map((step, i) => {
                const isDone    = doneSteps.includes(i);
                const isRunning = phase === 'running' && stepIndex === i && !isDone;
                return (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: isDone ? 'var(--success-bg)' : isRunning ? 'color-mix(in srgb, var(--brand-navy) 8%, var(--bg-elevated))' : 'var(--bg-subtle)', borderRadius: 8, border: '1px solid', borderColor: isDone ? 'color-mix(in srgb, var(--success) 25%, transparent)' : isRunning ? 'color-mix(in srgb, var(--brand-navy) 25%, transparent)' : 'var(--border)', transition: 'all 300ms' }}>
                    <div style={{ width: 22, height: 22, borderRadius: '50%', background: isDone ? 'var(--success)' : isRunning ? 'var(--brand-navy)' : 'var(--bg-elevated)', border: `2px solid ${isDone ? 'var(--success)' : isRunning ? 'var(--brand-navy)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 300ms' }}>
                      {isDone
                        ? <Icon name="check" size={11} style={{ color: 'white' }} />
                        : isRunning
                          ? <div style={{ width: 8, height: 8, borderRadius: '50%', border: '1.5px solid rgba(255,255,255,.4)', borderTop: '1.5px solid white', animation: 'spin 0.7s linear infinite' }} />
                          : <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)' }}>{i + 1}</span>
                      }
                    </div>
                    <span style={{ fontSize: 13, color: isDone ? 'var(--success)' : isRunning ? 'var(--text)' : 'var(--text-secondary)', fontWeight: isRunning ? 600 : 400 }}>{step}</span>
                  </div>
                );
              })}
            </div>
          </div>
          {phase === 'config' && (
            <div style={{ padding: '10px 14px', background: 'var(--warning-bg)', borderRadius: 8, fontSize: 12, color: 'var(--warning)', display: 'flex', gap: 8 }}>
              <Icon name="alert" size={13} style={{ flexShrink: 0, marginTop: 1 }} />
              {!tenant ? 'Selecione um tenant na aba Diagnóstico antes de executar.' : `Tenant: ${tenant.name} selecionado. Execute o diagnóstico se ainda não o fez.`}
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          <button className="btn" onClick={onClose} disabled={phase === 'running'}>Fechar</button>
          {phase === 'config' && <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={handleStart}><Icon name="play" size={14} />Iniciar execução</button>}
          {phase === 'running' && <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-muted)' }}><div style={{ width: 12, height: 12, borderRadius: '50%', border: '2px solid var(--border)', borderTop: '2px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite' }} />Etapa {stepIndex + 1} de {steps.length}…</div>}
          {phase === 'done' && <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={onClose}><Icon name="check" size={13} />Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Repairs Page ──────────────────────────────────────────────────────────────
const RepairsComingSoonPage = ({ onNav, tenantContext }) => (
  <div className="content" style={{ maxWidth: 640, margin: '0 auto' }}>
  <div className="card" style={{ padding: 32, textAlign: 'center' }}>
    <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
      <Icon name="wrench" size={24} style={{ color: 'var(--text-muted)' }} />
    </div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 8 }}>
      <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Repairs & Diagnóstico</h1>
      <span style={{ fontSize: 9, fontWeight: 700, color: 'var(--text-muted)', background: 'var(--bg-subtle)', padding: '2px 6px', borderRadius: 4, textTransform: 'uppercase' }}>Em breve</span>
    </div>
    <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 20 }}>
      O módulo de repairs, health checks e diagnóstico ainda não está disponível no backend.
      {tenantContext?.name ? ` Você veio do tenant ${tenantContext.name}.` : ''}
      {' '}Nenhuma chamada de API será feita até a integração estar pronta.
    </p>
    <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 24 }}>
      Para habilitar em desenvolvimento: <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>USE_REAL_REPAIRS_API = true</code> e <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>FEATURE_REPAIRS_MODULE = true</code> antes de carregar os componentes.
    </p>
    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
      <button type="button" className="btn primary" onClick={() => onNav && onNav({ page: 'lojas' })}>
        <Icon name="store" size={14} />Ir para Lojas
      </button>
      {tenantContext && (
        <button type="button" className="btn" onClick={() => onNav && onNav({ page: 'cockpit', storeId: tenantContext.tenant_id || tenantContext.id, pendingStore: true })}>
          Voltar ao Cockpit
        </button>
      )}
    </div>
  </div>
  </div>
);

const RepairsPage = ({ onToast, logAction, contextTicket, onNav, tenantContext }) => {
  const useRealApi = typeof saIsRealRepairsMode === 'function'
    ? saIsRealRepairsMode()
    : (typeof USE_REAL_REPAIRS_API !== 'undefined' && USE_REAL_REPAIRS_API);

  if (!useRealApi) {
    return <RepairsComingSoonPage onNav={onNav} tenantContext={tenantContext} />;
  }

  const { data: apiTenants, loading: tenantsLoading, error: tenantsError, refetch: refetchTenants } =
    useRealApi && typeof useTenants !== 'undefined'
      ? useTenants({ page: 1, page_size: 200 })
      : { data: null, loading: false, error: null, refetch: () => {} };

  const initialTenantId = tenantContext?.tenant_id || tenantContext?.id || contextTicket?.tenantId || '';
  const [tab,           setTab]           = useState('diagnostico');
  const [selectedTenant,setSelectedTenant]= useState(initialTenantId ? String(initialTenantId) : '');
  const [contextTenantMissing, setContextTenantMissing] = useState(false);
  const [healthData,    setHealthData]    = useState(null);
  const [healthError,   setHealthError]   = useState('');
  const [historyRows,   setHistoryRows]   = useState([]);
  const [historyLoading,setHistoryLoading]= useState(false);
  const [diagType,      setDiagType]      = useState('completo');
  const [diagResults,   setDiagResults]   = useState(null);
  const [diagRunning,   setDiagRunning]   = useState(false);
  const [repairModal,   setRepairModal]   = useState(null);
  const [apiRepairAction, setApiRepairAction] = useState(null);
  const [repairTenant,  setRepairTenant]  = useState(null);
  const [exportOpen,    setExportOpen]    = useState(false);
  const [dashboardModal,setDashboardModal]= useState(false);
  const [dashUrlCopied, setDashUrlCopied] = useState(false);

  // Ferramentas rápidas state
  const [toolStates,    setToolStates]    = useState({});
  const [domainResult,  setDomainResult]  = useState(null);
  const [cacheConfirm,  setCacheConfirm]  = useState(false);
  const [reindexState,  setReindexState]  = useState(null);
  const [reexecuteItem, setReexecuteItem] = useState(null);
  const [playbookItem,  setPlaybookItem]  = useState(null);
  const [extraHistory,  setExtraHistory]  = useState([]);
  const [repairOverview, setRepairOverview] = useState(null);
  const [repairKpiLoading, setRepairKpiLoading] = useState(false);
  const [repairKpiError, setRepairKpiError] = useState('');

  const MOCK_TENANTS = (FEATURED_TENANTS || []).map(t => ({
    id: t.tenant_id, name: t.name, schema: t.schema_name, status: t.status, plan: t.plan?.name || 'Basic',
  })).concat([
    { id: 130, name: 'Tech Sul',           schema: 'tech_sul',          status: 'active', plan: 'Pro' },
    { id: 1,   name: 'Petiskaria do Chef', schema: 'petiskaria_do_chef', status: 'active', plan: 'Pro' },
    { id: 2,   name: 'Moda Lis Atacado',   schema: 'moda_lis_atacado',   status: 'active', plan: 'Basic' },
    { id: 3,   name: 'Bodega 73',          schema: 'bodega_73',          status: 'active', plan: 'Pro' },
  ]);

  const tenantOptions = useRealApi
    ? (apiTenants || []).map(storeToRepairTenant).filter(Boolean)
    : MOCK_TENANTS;

  const tenantsLoadError = useRealApi && !!tenantsError && !tenantsLoading;
  const tenantsErrorMessage = tenantsLoadError
    ? 'Não foi possível carregar tenants reais.'
    : '';

  const currentTenant = tenantOptions.find(t => String(t.id) === String(selectedTenant)) || null;

  useEffect(() => {
    if (!useRealApi || tenantsLoading || tenantsError || !tenantContext) {
      setContextTenantMissing(false);
      return;
    }
    const tid = String(tenantContext.tenant_id ?? tenantContext.id ?? '');
    if (!tid) {
      setContextTenantMissing(false);
      return;
    }
    setContextTenantMissing(!tenantOptions.some(t => String(t.id) === tid));
  }, [useRealApi, tenantsLoading, tenantsError, tenantContext, tenantOptions]);

  const loadHealth = async (tenantId) => {
    if (!tenantId || !useRealApi) return;
    setHealthError('');
    setDiagRunning(true);
    try {
      const data = await repairService.getTenantHealth(tenantId);
      setHealthData(data);
      const tenant = tenantOptions.find(t => String(t.id) === String(tenantId)) || { id: tenantId, name: data.name, schema: data.schema_name };
      const results = (data.checks || []).map(c => ({
        id: c.key,
        label: c.label,
        status: mapApiCheckStatus(c.status),
        impact: c.status === 'error' ? c.detail : null,
        suggestion: c.status === 'warning' ? c.detail : null,
        detail: c.detail,
        repairAction: (data.available_repairs || []).find(r => r.action === 'sync_permissions' && c.key === 'role_permissions')?.action,
      }));
      setDiagResults({ tenant, results, health: data });
    } catch (e) {
      setHealthError(typeof formatRepairError !== 'undefined' ? formatRepairError(e) : (e?.message || 'Erro ao carregar health'));
      setDiagResults(null);
      setHealthData(null);
    } finally {
      setDiagRunning(false);
    }
  };

  const loadHistory = async (tenantId) => {
    if (!tenantId || !useRealApi) return;
    setHistoryLoading(true);
    try {
      const rows = await repairService.getRepairHistory(tenantId);
      setHistoryRows(rows);
    } catch (e) {
      setHistoryRows([]);
      onToast && onToast(typeof formatRepairError !== 'undefined' ? formatRepairError(e) : 'Erro ao carregar histórico');
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (useRealApi && selectedTenant && !tenantsLoading && !tenantsError) loadHealth(selectedTenant);
  }, [useRealApi, selectedTenant, tenantsLoading, tenantsError]);

  useEffect(() => {
    if (tab === 'historico' && useRealApi && selectedTenant) loadHistory(selectedTenant);
  }, [tab, selectedTenant, useRealApi]);

  const setTool = (key, state, duration = 2200) => {
    setToolStates(prev => ({ ...prev, [key]: state }));
    if (state === 'copied' || state === 'done') {
      setTimeout(() => setToolStates(prev => ({ ...prev, [key]: null })), duration);
    }
  };

  const requireTenant = () => {
    if (!currentTenant) { onToast && onToast('Selecione um tenant primeiro'); return false; }
    return true;
  };

  const REPS_TABS = [
    { id: 'diagnostico', label: 'Diagnóstico' },
    { id: 'repairs',     label: 'Repairs disponíveis' },
    { id: 'historico',   label: 'Histórico' },
    { id: 'playbooks',   label: 'Playbooks' },
    { id: 'ferramentas', label: 'Ferramentas rápidas' },
  ];

  const runDiag = () => {
    if (!selectedTenant) { onToast && onToast('Selecione um tenant primeiro'); return; }
    if (useRealApi) {
      loadHealth(selectedTenant).then(() => onToast && onToast(`Health check de ${currentTenant?.name || 'tenant'} atualizado`));
      return;
    }
    setDiagRunning(true);
    setDiagResults(null);
    setTimeout(() => {
      const tenant = tenantOptions.find(t => String(t.id) === String(selectedTenant));
      const isModa = tenant?.id === 103;
      const results = DIAG_CHECKS.map(c => ({
        ...c,
        status: isModa && ['partneraddr','search'].includes(c.id) ? 'falha' : isModa && ['settings'].includes(c.id) ? 'aviso' : 'ok',
        impact: isModa && c.id === 'partneraddr' ? 'Checkout sem endereço de faturamento' : null,
        suggestion: isModa && c.id === 'partneraddr' ? 'Execute o repair "Recriar centro de distribuição"' : null,
      }));
      setDiagResults({ tenant, results });
      setDiagRunning(false);
      onToast && onToast(`Diagnóstico de ${tenant?.name} concluído`);
    }, 2200);
  };

  const openApiRepair = (action, tenant = null) => {
    setApiRepairAction(action);
    setRepairTenant(tenant || currentTenant);
  };

  useEffect(() => {
    if (!useRealApi || !repairService?.getOverview) return;
    let cancelled = false;
    setRepairKpiLoading(true);
    setRepairKpiError('');
    repairService.getOverview({ days: 30 })
      .then((data) => {
        if (!cancelled) setRepairOverview(data);
      })
      .catch((e) => {
        if (!cancelled) {
          setRepairOverview(null);
          setRepairKpiError(e?.message || 'Erro ao carregar KPIs de repairs');
        }
      })
      .finally(() => { if (!cancelled) setRepairKpiLoading(false); });
  }, [useRealApi]);

  const overviewTotals = repairOverview?.totals || {};
  const kpis = useRealApi ? [
    { label: 'Repairs (30 dias)', value: repairKpiLoading ? '…' : (overviewTotals.executed ?? '—'), icon: 'wrench' },
    { label: 'Com sucesso', value: repairKpiLoading ? '…' : (overviewTotals.success ?? '—'), icon: 'check', ok: true },
    { label: 'Com falha', value: repairKpiLoading ? '…' : (overviewTotals.failed ?? '—'), icon: 'x', danger: true },
    { label: 'Indisponível', value: repairKpiLoading ? '…' : (overviewTotals.not_available ?? '—'), icon: 'alert', warn: true },
    { label: 'Tenants c/ problema', value: tenantOptions.filter(t => ['provisioning_failed', 'overdue', 'suspended'].includes(t.status)).length, icon: 'alert', warn: true },
    { label: 'Janela', value: repairKpiLoading ? '…' : `${repairOverview?.recent_window?.days || 30}d`, icon: 'clock', small: true },
  ] : [
    { label: 'Repairs hoje',       value: HISTORY_MOCK.filter(h => h.ts.startsWith('Hoje')).length,                         icon: 'wrench' },
    { label: 'Com sucesso',        value: HISTORY_MOCK.filter(h => h.result === 'success').length,                          icon: 'check',  ok: true },
    { label: 'Com falha',          value: HISTORY_MOCK.filter(h => h.result !== 'success' && h.result !== 'parcial').length, icon: 'x',      danger: true },
    { label: 'Tenants c/ problema',value: 2,                                                                                 icon: 'alert',  warn: true },
    { label: 'Diags pendentes',    value: 1,                                                                                 icon: 'clock' },
    { label: 'Último crítico',     value: 'Hoje, 11:30',                                                                    icon: 'clock',  small: true },
  ];

  const openRepair = (repair, tenant = null) => {
    setRepairModal(repair);
    setRepairTenant(tenant || currentTenant || null);
  };

  const RepairCard = ({ repair, tenant }) => {
    const rc = RISK_CONFIG[repair.risk] || RISK_CONFIG.baixo;
    return (
      <div className="card" style={{ padding: 14, borderLeft: `3px solid ${rc.color}` }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 8 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{repair.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2, lineHeight: 1.4 }}>{repair.desc}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
          <RiskBadge risk={repair.risk} />
          <span className={`badge ${repair.reversible ? 'success' : 'neutral'}`} style={{ fontSize: 10 }}><span className="dot" />{repair.reversible ? 'Reversível' : 'Irreversível'}</span>
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{repair.requiresReason ? '· motivo obrigatório' : ''}</span>
          <button className="btn sm primary" style={{ marginLeft: 'auto' }} onClick={() => openRepair(repair, tenant)}>
            <Icon name="wrench" size={12} />Executar
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="content wide" style={{ maxWidth: 1280 }}>
      {/* Ticket context banner */}
      {tenantContext && useRealApi && (
        <div style={{ background: 'color-mix(in srgb, var(--info) 8%, var(--bg-elevated))', border: '1px solid color-mix(in srgb, var(--info) 30%, var(--border))', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <Icon name="wrench" size={16} style={{ color: 'var(--info)', flexShrink: 0 }} />
          <div style={{ flex: 1, fontWeight: 600, fontSize: 13 }}>Diagnóstico aberto para {tenantContext.name}</div>
          {tenantContext.tenant_id && <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>tenant_id={tenantContext.tenant_id}</code>}
        </div>
      )}

      {contextTicket && (
        <div style={{ background: 'color-mix(in srgb, var(--info) 8%, var(--bg-elevated))', border: '1px solid color-mix(in srgb, var(--info) 30%, var(--border))', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="messageCircle" size={15} style={{ color: 'var(--info)' }} />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>Diagnóstico aberto a partir do Ticket {contextTicket.id} — {contextTicket.tenant}</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>{contextTicket.subject}{contextTicket.priority && <span style={{ marginLeft: 8, fontStyle: 'italic', color: 'var(--text-muted)' }}>· Prioridade: {contextTicket.priority}</span>}</div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            {contextTicket.plan && <span className="badge info" style={{ fontSize: 11 }}><span className="dot" />{contextTicket.plan}</span>}
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Tenant pré-selecionado</span>
            <button className="btn sm" onClick={() => onNav && onNav({ page: 'tickets', openTicketId: contextTicket.id })}><Icon name="chevronLeft" size={12} />Voltar ao ticket</button>
          </div>
        </div>
      )}

      <div className="page-header">
        <div>
          <h1>Repairs & Diagnóstico</h1>
          <p className="sub">Ferramentas técnicas para diagnóstico, correção e manutenção de tenants.</p>
        </div>
        <div className="actions">
          <button className="btn" onClick={() => setExportOpen(true)}><Icon name="download" size={14} />Exportar relatório</button>
          {!useRealApi && <button className="btn" onClick={() => setTab('playbooks')}><Icon name="list" size={14} />Playbooks</button>}
          <button className="btn" onClick={() => setTab('historico')}><Icon name="clock" size={14} />Histórico de repairs</button>
          <button className="btn primary" onClick={() => setTab('diagnostico')}><Icon name="activity" size={14} />Novo diagnóstico</button>
        </div>
      </div>

      {useRealApi && repairKpiError && (
        <div className="hint-card" style={{ marginBottom: 16, padding: 12, borderColor: 'var(--danger)', color: 'var(--danger)' }}>
          {repairKpiError}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 24 }}>
        {kpis.map(k => (
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14} />{k.label}</div>
            <div className="value" style={{ fontSize: k.small ? 14 : 26, color: k.danger ? 'var(--danger)' : k.ok ? 'var(--success)' : k.warn ? 'var(--warning)' : undefined }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 24 }}>
        {REPS_TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '9px 16px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: tab===t.id?600:500, color: tab===t.id?'var(--text)':'var(--text-muted)', borderBottom: tab===t.id?'2px solid var(--brand-navy)':'2px solid transparent', marginBottom: -1, cursor: 'pointer', transition: 'color 120ms' }}>{t.label}</button>
        ))}
      </div>

      {/* ── Diagnóstico ── */}
      {tab === 'diagnostico' && (
        <div style={{ display: 'grid', gridTemplateColumns: '320px 1fr', gap: 24, alignItems: 'start' }}>
          <div className="card" style={{ padding: 18 }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 14 }}>Configurar diagnóstico</div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text-muted)', marginBottom: 6, fontWeight: 500 }}>Tenant</label>
              {useRealApi && tenantsLoading && (
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>Carregando tenants…</div>
              )}
              {useRealApi && tenantsLoadError && (
                <div style={{ padding: '10px 12px', marginBottom: 8, background: 'var(--danger-bg)', borderRadius: 8, fontSize: 12, color: 'var(--danger)' }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{tenantsErrorMessage}</div>
                  {tenantsError && <div style={{ marginBottom: 8, opacity: 0.9 }}>{tenantsError}</div>}
                  <button type="button" className="btn sm" onClick={refetchTenants}><Icon name="refresh" size={12} />Tentar novamente</button>
                </div>
              )}
              {useRealApi && contextTenantMissing && (
                <div style={{ padding: '10px 12px', marginBottom: 8, background: 'var(--warning-bg)', borderRadius: 8, fontSize: 12, color: 'var(--warning)' }}>
                  Tenant &quot;{tenantContext?.name || initialTenantId}&quot; não encontrado na lista retornada pela API.
                </div>
              )}
              <select className="select" style={{ width: '100%' }} value={selectedTenant} onChange={e => setSelectedTenant(e.target.value)} disabled={useRealApi && (tenantsLoading || tenantsLoadError)}>
                <option value="">{useRealApi && tenantsLoading ? 'Carregando tenants…' : 'Selecionar tenant…'}</option>
                {tenantOptions.map(t => <option key={t.id} value={t.id}>{t.name}{t.domain ? ` · ${t.domain}` : ''}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--text-muted)', marginBottom: 6, fontWeight: 500 }}>Tipo de diagnóstico</label>
              <select className="select" style={{ width: '100%' }} value={diagType} onChange={e => setDiagType(e.target.value)}>
                {['Completo','Provisionamento','Domínios','Permissões','Usuários','Busca','Storage','Billing','Integrações'].map(d => (
                  <option key={d} value={d.toLowerCase()}>{d}</option>
                ))}
              </select>
            </div>
            <button className="btn primary" style={{ width: '100%', justifyContent: 'center' }} onClick={runDiag} disabled={diagRunning}>
              {diagRunning
                ? <><div style={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Executando…</>
                : <><Icon name="activity" size={14} />Executar diagnóstico</>
              }
            </button>
          </div>

          <div>
            {!diagResults && !diagRunning && (
              <div className="hint-card" style={{ padding: '28px 20px', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', gap: 12 }}>
                <Icon name="activity" size={32} style={{ opacity: 0.3 }} />
                <div style={{ fontWeight: 500 }}>Selecione um tenant e execute o diagnóstico</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Os resultados serão exibidos aqui com sugestões de repair</div>
              </div>
            )}
            {diagRunning && (
              <div className="hint-card" style={{ padding: '28px 20px', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', gap: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto' }} />
                <div style={{ fontWeight: 500 }}>Executando diagnóstico…</div>
              </div>
            )}
            {healthError && (
              <div style={{ padding: 12, marginBottom: 12, background: 'var(--danger-bg)', borderRadius: 8, fontSize: 13, color: 'var(--danger)' }}>{healthError}</div>
            )}
            {useRealApi && healthData && (
              <div className="card" style={{ padding: 14, marginBottom: 12, fontSize: 12 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                  <div><span style={{ color: 'var(--text-muted)' }}>tenant_id</span><div style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }}>{healthData.tenant_id}</div></div>
                  <div><span style={{ color: 'var(--text-muted)' }}>schema</span><div style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }}>{healthData.schema_name}</div></div>
                  <div><span style={{ color: 'var(--text-muted)' }}>domínio</span><div style={{ fontWeight: 500 }}>{healthData.domain || '—'}</div></div>
                  <div><span style={{ color: 'var(--text-muted)' }}>plano</span><div>{healthData.plan_label || healthData.plan}</div></div>
                  <div><span style={{ color: 'var(--text-muted)' }}>status comercial</span><div>{healthData.commercial_status_label || healthData.commercial_status}</div></div>
                  <div><span style={{ color: 'var(--text-muted)' }}>schema_accessible</span><div>{healthData.schema_accessible ? 'Sim' : 'Não'}</div></div>
                </div>
              </div>
            )}
            {diagResults && (
              <div>
                <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{diagResults.tenant?.name}</div>
                  <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{diagResults.tenant?.schema}</code>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>{diagResults.results.filter(r => r.status === 'ok').length}/{diagResults.results.length} OK</span>
                </div>
                <div style={{ border: '1px solid var(--border)', borderRadius: 10, overflow: 'hidden' }}>
                  {diagResults.results.map((item, i) => (
                    <div key={item.id} style={{ padding: '10px 16px', borderBottom: i < diagResults.results.length-1 ? '1px solid var(--border)' : 'none', display: 'flex', alignItems: 'center', gap: 12, background: item.status==='falha'?'color-mix(in srgb, var(--danger-bg) 40%, var(--bg-elevated))':item.status==='aviso'?'color-mix(in srgb, var(--warning-bg) 30%, var(--bg-elevated))':'var(--bg-elevated)' }}>
                      <div style={{ width: 20, height: 20, borderRadius: '50%', background: item.status==='ok'?'var(--success-bg)':item.status==='aviso'?'var(--warning-bg)':'var(--danger-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Icon name={item.status==='ok'?'check':'alert'} size={12} style={{ color: item.status==='ok'?'var(--success)':item.status==='aviso'?'var(--warning)':'var(--danger)' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500 }}>{item.label}</div>
                        {item.detail && useRealApi && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{item.detail}</div>}
                        {item.impact     && <div style={{ fontSize: 11, color: 'var(--danger)',   marginTop: 2 }}>{item.impact}</div>}
                        {item.suggestion && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1, fontStyle: 'italic' }}>{item.suggestion}</div>}
                      </div>
                      {useRealApi && item.status !== 'ok' && healthData?.available_repairs?.length > 0 && (
                        <button className="btn sm" onClick={() => {
                          const action = healthData.available_repairs.find(a => a.action === 'sync_permissions') || healthData.available_repairs[0];
                          if (action) openApiRepair(action, diagResults.tenant);
                        }}><Icon name="wrench" size={11} />Repair</button>
                      )}
                      {!useRealApi && item.status !== 'ok' && item.repairId && (
                        <button className="btn sm danger-outline" onClick={() => {
                          const allRepairs = REPAIR_CATEGORIES.flatMap(c => c.repairs);
                          const repair = allRepairs.find(r => r.id === item.repairId);
                          if (repair) openRepair(repair, diagResults.tenant);
                        }}><Icon name="wrench" size={11} />Reparar</button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Repairs disponíveis ── */}
      {tab === 'repairs' && (
        <div>
          <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>Tenant:</label>
            {useRealApi && tenantsLoadError && (
              <div style={{ flex: '1 1 100%', padding: '10px 12px', background: 'var(--danger-bg)', borderRadius: 8, fontSize: 12, color: 'var(--danger)' }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{tenantsErrorMessage}</div>
                <button type="button" className="btn sm" onClick={refetchTenants}><Icon name="refresh" size={12} />Tentar novamente</button>
              </div>
            )}
            <select className="select" value={selectedTenant} onChange={e => setSelectedTenant(e.target.value)} disabled={useRealApi && (tenantsLoading || tenantsLoadError)}>
              <option value="">Selecionar (opcional)…</option>
              {tenantOptions.map(t => <option key={t.id} value={t.id}>{t.name}{t.domain ? ` · ${t.domain}` : ''}</option>)}
            </select>
          </div>
          {useRealApi && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10, marginBottom: 20 }}>
              {(healthData?.available_repairs || []).map(action => (
                <div key={action.action} className="card" style={{ padding: 14 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>{action.label}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 10 }}>{action.action}{action.requires_reason ? ' · motivo obrigatório' : ''}</div>
                  <button className="btn sm primary" disabled={!currentTenant} onClick={() => openApiRepair(action)}>
                    <Icon name="wrench" size={12} />Executar
                  </button>
                </div>
              ))}
              {!healthData?.available_repairs?.length && currentTenant && (
                <div className="hint-card" style={{ padding: 16 }}>Execute o health check na aba Diagnóstico para ver repairs disponíveis.</div>
              )}
            </div>
          )}
          {useRealApi && (
            <div style={{ padding: '12px 16px', background: 'var(--bg-subtle)', borderRadius: 8, marginBottom: 16, fontSize: 12, color: 'var(--text-muted)' }}>
              Repairs avançados do protótipo (provisionamento destrutivo, tokens, playbooks) estão fora do MVP.
            </div>
          )}
          {!useRealApi && REPAIR_CATEGORIES.map(cat => (
            <div key={cat.name} style={{ marginBottom: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <Icon name={cat.icon} size={16} style={{ color: 'var(--text-muted)' }} />
                <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>{cat.name}</h3>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{cat.repairs.length} repairs</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 10 }}>
                {cat.repairs.map(r => <RepairCard key={r.id} repair={r} tenant={currentTenant} />)}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── Histórico ── */}
      {tab === 'historico' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>Histórico de repairs</h3>
            <span style={{ fontSize: 12, color: 'var(--text-muted)', marginLeft: 8 }}>
              {useRealApi ? (historyLoading ? 'Carregando…' : `${historyRows.length} registros`) : `${HISTORY_MOCK.length} execuções`}
            </span>
            {useRealApi && (
              <>
                {tenantsLoadError && (
                  <div style={{ flex: '1 1 100%', padding: '10px 12px', background: 'var(--danger-bg)', borderRadius: 8, fontSize: 12, color: 'var(--danger)' }}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>{tenantsErrorMessage}</div>
                    <button type="button" className="btn sm" onClick={refetchTenants}><Icon name="refresh" size={12} />Tentar novamente</button>
                  </div>
                )}
                <select className="select" style={{ marginLeft: tenantsLoadError ? 0 : 'auto', height: 32 }} value={selectedTenant} onChange={e => { setSelectedTenant(e.target.value); }} disabled={tenantsLoading || tenantsLoadError}>
                  <option value="">{tenantsLoading ? 'Carregando tenants…' : 'Selecionar tenant…'}</option>
                  {tenantOptions.map(t => <option key={t.id} value={t.id}>{t.name}{t.domain ? ` · ${t.domain}` : ''}</option>)}
                </select>
              </>
            )}
          </div>
          {useRealApi ? (
            <table className="data">
              <thead><tr><th>Data</th><th>Ação</th><th>Ator</th><th>Resultado</th><th>Motivo</th></tr></thead>
              <tbody>
                {historyRows.map(h => (
                  <tr key={h.id}>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{h.created_at ? new Date(h.created_at).toLocaleString('pt-BR') : '—'}</td>
                    <td>{h.action_label || h.action}</td>
                    <td style={{ fontSize: 13 }}>{h.actor?.email || '—'}</td>
                    <td><span className={`badge ${h.result === 'success' ? 'success' : 'danger'}`}><span className="dot" />{h.result}</span></td>
                    <td style={{ fontSize: 12, maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}>{h.reason || '—'}</td>
                  </tr>
                ))}
                {!historyRows.length && !historyLoading && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', padding: 24, color: 'var(--text-muted)' }}>Nenhum repair registrado para este tenant.</td></tr>
                )}
              </tbody>
            </table>
          ) : (
          <table className="data">
            <thead><tr><th>Data/hora</th><th>Tenant</th><th>Repair</th><th>Executado por</th><th>Resultado</th><th>Duração</th><th>Motivo</th><th style={{ textAlign:'right' }}>Ações</th></tr></thead>
            <tbody>
              {[...extraHistory, ...HISTORY_MOCK].map((h,i) => (
                <tr key={i}>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{h.ts}</td>
                  <td style={{ fontWeight: 500 }}>{h.tenant}</td>
                  <td style={{ fontSize: 13 }}>{h.repair}</td>
                  <td style={{ fontSize: 13 }}>{h.by}</td>
                  <td><span className={`badge ${h.result==='success'?'success':h.result==='parcial'?'warning':'danger'}`}><span className="dot" />{h.result}</span></td>
                  <td style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>{h.duration}</td>
                  <td style={{ fontSize: 12, color: 'var(--text-secondary)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.reason}</td>
                  <td>
                    <div className="row-actions">
                      <button className="icon-action" title="Ver logs"><Icon name="terminal" size={13} /></button>
                      <button className="icon-action" title="Ver auditoria"><Icon name="audit" size={13} /></button>
                      <button className="icon-action" title="Reexecutar" onClick={() => setReexecuteItem(h)}><Icon name="refresh" size={13} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          )}
        </div>
      )}

      {/* ── Playbooks ── */}
      {tab === 'playbooks' && (
        useRealApi ? (
          <div className="hint-card" style={{ padding: 24, flexDirection: 'column', gap: 8, textAlign: 'center' }}>
            <Icon name="list" size={28} style={{ opacity: 0.35 }} />
            <div style={{ fontWeight: 600 }}>Playbooks avançados — fora do MVP</div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Use Diagnóstico e Repairs disponíveis para ações allowlisted da Fase 8.</div>
          </div>
        ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 14 }}>
          {PLAYBOOKS.map((pb,i) => (
            <div key={i} className="card" style={{ padding: 16 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: 7, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon name="list" size={15} style={{ color: 'var(--info)' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, lineHeight: 1.3 }}>{pb.symptom}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Diagnóstico: {pb.diag} · {pb.repairs.length} repairs</div>
                </div>
                <RiskBadge risk={pb.risk} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
                {pb.steps.map((step,si) => (
                  <div key={si} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, color: 'var(--text-secondary)' }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)', marginTop: 2, flexShrink: 0 }}>{si+1}.</span>
                    {step}
                  </div>
                ))}
              </div>
              <button className="btn sm primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => setPlaybookItem(pb)}>
                <Icon name="play" size={12} />Iniciar playbook
              </button>
            </div>
          ))}
        </div>
        )
      )}

      {/* ── Ferramentas rápidas ── */}
      {tab === 'ferramentas' && (
        <div>
          <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 500 }}>Tenant:</label>
            <select className="select" value={selectedTenant} onChange={e => { setSelectedTenant(e.target.value); setDomainResult(null); }}>
              <option value="">Selecionar tenant…</option>
              {MOCK_TENANTS.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
            {currentTenant && (
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11, background: 'var(--bg-subtle)', padding: '2px 6px', borderRadius: 4 }}>ID {currentTenant.id}</code>
                {' '}·{' '}
                <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11, background: 'var(--bg-subtle)', padding: '2px 6px', borderRadius: 4 }}>{currentTenant.schema}</code>
              </span>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(168px, 1fr))', gap: 10 }}>
            {/* Abrir Tenant Cockpit */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => {
              if (!requireTenant()) return;
              const store = { id: currentTenant.id, name: currentTenant.name, schema_name: currentTenant.schema, status: currentTenant.status, plan: { name: currentTenant.plan, price: 0 } };
              onNav && onNav({ page: 'cockpit', store });
            }}>
              <Icon name="dashboard" size={18} style={{ color: 'var(--brand-navy)' }} />Abrir Tenant Cockpit
            </button>

            {/* Copiar Tenant ID */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: toolStates['tenantId'] === 'copied' ? 'var(--success)' : 'var(--text-secondary)', transition: 'color 200ms' }} onClick={() => {
              if (!requireTenant()) return;
              navigator.clipboard?.writeText(String(currentTenant.id));
              setTool('tenantId', 'copied');
            }}>
              <Icon name={toolStates['tenantId'] === 'copied' ? 'check' : 'copy'} size={18} style={{ color: toolStates['tenantId'] === 'copied' ? 'var(--success)' : 'var(--brand-navy)', transition: 'color 200ms' }} />
              {toolStates['tenantId'] === 'copied' ? 'Copiado!' : 'Copiar Tenant ID'}
            </button>

            {/* Copiar Schema */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: toolStates['schema'] === 'copied' ? 'var(--success)' : 'var(--text-secondary)', transition: 'color 200ms' }} onClick={() => {
              if (!requireTenant()) return;
              navigator.clipboard?.writeText(currentTenant.schema);
              setTool('schema', 'copied');
            }}>
              <Icon name={toolStates['schema'] === 'copied' ? 'check' : 'copy'} size={18} style={{ color: toolStates['schema'] === 'copied' ? 'var(--success)' : 'var(--brand-navy)', transition: 'color 200ms' }} />
              {toolStates['schema'] === 'copied' ? 'Copiado!' : 'Copiar Schema'}
            </button>

            {/* Abrir dashboard */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => {
              if (!requireTenant()) return;
              setDashboardModal(true);
            }}>
              <Icon name="externalLink" size={18} style={{ color: 'var(--brand-navy)' }} />Abrir dashboard
            </button>

            {/* Validar domínio */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: toolStates['domain'] === 'loading' ? 'var(--text-muted)' : 'var(--text-secondary)' }} onClick={async () => {
              if (!requireTenant()) return;
              if (toolStates['domain'] === 'loading') return;
              setDomainResult(null);
              setTool('domain', 'loading', 99999);
              if (useRealApi) {
                try {
                  const r = await repairService.runRepair(currentTenant.id, { action: 'validate_domain' });
                  setDomainResult({ tenant: currentTenant.name, valid: r.result?.valid, message: r.message, domain: r.result?.domain || currentTenant.domain });
                  onToast && onToast(r.message || 'Validação concluída');
                } catch (e) {
                  onToast && onToast(typeof formatRepairError !== 'undefined' ? formatRepairError(e) : 'Erro na validação');
                } finally {
                  setToolStates(prev => ({ ...prev, domain: null }));
                }
                return;
              }
              setTimeout(() => {
                setToolStates(prev => ({ ...prev, domain: null }));
                const mockDom = currentTenant.domain || (typeof buildMockTenantDomain === 'function' ? buildMockTenantDomain((currentTenant.schema_name || currentTenant.schema || 'tenant').replace(/_/g, '-')) : `${(currentTenant.schema_name || 'tenant').replace(/_/g, '-')}.localhost`);
                setDomainResult({ tenant: currentTenant.name, dns: 'OK', ssl: 'Válido até 2027-03-15', http: '200 OK', latency: '124ms', domain: mockDom });
              }, 1600);
            }}>
              {toolStates['domain'] === 'loading'
                ? <div style={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid var(--border)', borderTop: '2px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite' }} />
                : <Icon name="globe" size={18} style={{ color: 'var(--brand-navy)' }} />
              }
              {toolStates['domain'] === 'loading' ? 'Validando…' : 'Validar domínio'}
            </button>

            {/* Limpar cache */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => { if (!requireTenant()) return; setCacheConfirm(true); }}>
              <Icon name="zap" size={18} style={{ color: 'var(--brand-navy)' }} />Limpar cache
            </button>

            {/* Reindexar busca */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => { if (!requireTenant()) return; setReindexState('confirm'); }}>
              <Icon name="search" size={18} style={{ color: 'var(--brand-navy)' }} />Reindexar busca
            </button>

            {/* Ver auditoria */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => {
              if (!requireTenant()) return;
              onNav && onNav({ page: 'auditoria', tenantContext: { id: currentTenant.id, name: currentTenant.name } });
            }}>
              <Icon name="audit" size={18} style={{ color: 'var(--brand-navy)' }} />Ver auditoria
            </button>

            {/* Ver logs */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => {
              if (!requireTenant()) return;
              onNav && onNav({ page: 'observabilidade', tenantContext: { id: currentTenant.id, name: currentTenant.name } });
            }}>
              <Icon name="terminal" size={18} style={{ color: 'var(--brand-navy)' }} />Ver logs
            </button>

            {/* Ver tokens */}
            <button className="btn" style={{ height: 64, flexDirection: 'column', gap: 6, justifyContent: 'center', fontSize: 12, color: 'var(--text-secondary)' }} onClick={() => {
              if (!requireTenant()) return;
              onNav && onNav({ page: 'integrations', tenantContext: { id: currentTenant.id, name: currentTenant.name } });
            }}>
              <Icon name="key" size={18} style={{ color: 'var(--brand-navy)' }} />Ver tokens
            </button>
          </div>

          {/* Domain validation result */}
          {domainResult && (
            <div style={{ marginTop: 16, padding: '14px 16px', background: 'var(--success-bg)', borderRadius: 10, border: '1px solid color-mix(in srgb, var(--success) 30%, transparent)', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ width: 32, height: 32, borderRadius: 7, background: 'var(--success-bg)', border: '1px solid color-mix(in srgb, var(--success) 40%, transparent)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon name="check" size={15} style={{ color: 'var(--success)' }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--text)', marginBottom: 6 }}>Domínio validado — {domainResult.tenant}</div>
                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 12 }}>
                  {[['Domínio',domainResult.domain],['DNS',domainResult.dns],['SSL',domainResult.ssl],['HTTP',domainResult.http],['Latência',domainResult.latency]].map(([k,v]) => (
                    <div key={k}><span style={{ color: 'var(--text-muted)' }}>{k}: </span><span style={{ fontWeight: 600, color: 'var(--text)' }}>{v}</span></div>
                  ))}
                </div>
              </div>
              <button className="icon-action" onClick={() => setDomainResult(null)}><Icon name="x" size={14} /></button>
            </div>
          )}
        </div>
      )}

      {/* ── Cache confirm modal ── */}
      {cacheConfirm && (
        <div onClick={() => setCacheConfirm(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: 420, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
            <div style={{ padding: '24px 24px 20px', textAlign: 'center' }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--warning-bg)', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon name="zap" size={22} style={{ color: 'var(--warning)' }} />
              </div>
              <h3 style={{ fontSize: 17, fontWeight: 600, marginBottom: 8 }}>Limpar cache de {currentTenant?.name}?</h3>
              <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0 }}>Todas as chaves Redis do tenant serão removidas. A loja pode ficar brevemente mais lenta até o cache ser reaquecido.</p>
            </div>
            <div style={{ padding: '12px 20px', background: 'var(--bg-subtle)', display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setCacheConfirm(false)}>Cancelar</button>
              <button className="btn primary" onClick={() => {
                setCacheConfirm(false);
                if (useRealApi) {
                  openApiRepair({ action: 'clear_cache', label: 'Limpar cache', severity: 'safe', requires_reason: true });
                  return;
                }
                setTool('cache', 'done');
                onToast && onToast(`Cache de ${currentTenant?.name} limpo com sucesso`);
                logAction && logAction({ acao: `Cache limpo: ${currentTenant?.name}`, loja: currentTenant?.name || '—', kind: 'info' });
              }}><Icon name="zap" size={14} />Limpar cache</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Reindex modal ── */}
      {reindexState && (
        <div onClick={reindexState === 'running' ? undefined : () => setReindexState(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: 420, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
            {reindexState === 'confirm' && (
              <>
                <div style={{ padding: '24px 24px 20px', textAlign: 'center' }}>
                  <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--info-bg)', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon name="search" size={22} style={{ color: 'var(--info)' }} />
                  </div>
                  <h3 style={{ fontSize: 17, fontWeight: 600, marginBottom: 8 }}>Reindexar busca de {currentTenant?.name}?</h3>
                  <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0 }}>Todos os produtos serão reindexados no OpenSearch. O processo pode levar alguns segundos.</p>
                </div>
                <div style={{ padding: '12px 20px', background: 'var(--bg-subtle)', display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button className="btn" onClick={() => setReindexState(null)}>Cancelar</button>
                  <button className="btn primary" onClick={() => {
                    if (useRealApi) {
                      setReindexState(null);
                      openApiRepair({ action: 'reindex_search', label: 'Reindexar busca', severity: 'safe', requires_reason: true });
                      return;
                    }
                    setReindexState('running');
                    setTimeout(() => {
                      setReindexState('done');
                      logAction && logAction({ acao: `Busca reindexada: ${currentTenant?.name}`, loja: currentTenant?.name || '—', kind: 'info' });
                    }, 2800);
                  }}><Icon name="search" size={14} />Reindexar</button>
                </div>
              </>
            )}
            {reindexState === 'running' && (
              <div style={{ padding: '36px 24px', textAlign: 'center' }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
                <div style={{ fontWeight: 600, fontSize: 15 }}>Reindexando produtos…</div>
                <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>Enviando ao OpenSearch — aguarde</div>
              </div>
            )}
            {reindexState === 'done' && (
              <>
                <div style={{ padding: '28px 24px 20px', textAlign: 'center' }}>
                  <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
                    <Icon name="check" size={22} style={{ color: 'var(--success)' }} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 16 }}>Reindexação concluída</div>
                  <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 6 }}>{currentTenant?.name} · índice atualizado com sucesso</div>
                </div>
                <div style={{ padding: '12px 20px', background: 'var(--bg-subtle)', display: 'flex', justifyContent: 'flex-end' }}>
                  <button className="btn primary" onClick={() => setReindexState(null)}>Concluir</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── Dashboard preview modal ── */}
      {dashboardModal && currentTenant && ((() => {
        const tenantUrl = `https://dashboard.tezus.com.br/${currentTenant.schema}`;
        const statusColors = { active: 'var(--success)', ativo: 'var(--success)', suspended: 'var(--text-muted)', suspenso: 'var(--text-muted)', trial: 'var(--info)' };
        const statusColor = statusColors[currentTenant.status] || 'var(--success)';
        return (
          <div onClick={() => setDashboardModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div onClick={e => e.stopPropagation()} style={{ width: 480, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
              {/* Header */}
              <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 42, height: 42, borderRadius: 10, background: 'var(--brand-navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: 'white', flexShrink: 0 }}>
                  {currentTenant.name.split(' ').filter(w => w.length > 1).slice(0, 2).map(w => w[0]).join('')}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{currentTenant.name}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{currentTenant.schema}</div>
                </div>
                <button className="icon-action" onClick={() => setDashboardModal(false)}><Icon name="x" size={16} /></button>
              </div>

              {/* Info rows */}
              <div style={{ padding: '16px 22px' }}>
                <div style={{ marginBottom: 16 }}>
                  {[
                    ['Domínio', currentTenant.domain || (typeof buildMockTenantDomain === 'function' ? buildMockTenantDomain(String(currentTenant.schema_name || currentTenant.schema || 'tenant').replace(/_/g, '-')) : '—')],
                    ['Status',  currentTenant.status],
                    ['Plano',   currentTenant.plan],
                    ['ID',      `#${currentTenant.id}`],
                  ].map(([label, value]) => (
                    <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--border)' }}>
                      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{label}</span>
                      <span style={{ fontSize: 13, fontWeight: 500, color: label === 'Status' ? statusColor : 'var(--text)', textTransform: label === 'Status' ? 'capitalize' : 'none' }}>{value}</span>
                    </div>
                  ))}
                </div>

                {/* URL do dashboard */}
                <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, border: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                  <code style={{ flex: 1, fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tenantUrl}</code>
                  <button className="btn sm" onClick={() => { navigator.clipboard?.writeText(tenantUrl); setDashUrlCopied(true); setTimeout(() => setDashUrlCopied(false), 2200); }}>
                    <Icon name={dashUrlCopied ? 'check' : 'copy'} size={12} />{dashUrlCopied ? 'Copiado' : 'Copiar URL'}
                  </button>
                </div>

                {/* Atalhos */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>Atalhos</div>
                  <button className="btn primary" style={{ justifyContent: 'flex-start', gap: 10 }} onClick={() => {
                    onNav && onNav({ page: 'cockpit', store: { id: currentTenant.id, name: currentTenant.name, schema_name: currentTenant.schema, status: currentTenant.status, plan: { name: currentTenant.plan, price: 0 } } });
                    setDashboardModal(false);
                  }}>
                    <Icon name="dashboard" size={14} />Abrir Tenant Cockpit
                  </button>
                  <button className="btn" style={{ justifyContent: 'flex-start', gap: 10 }} onClick={() => {
                    navigator.clipboard?.writeText(tenantUrl);
                    setDashUrlCopied(true);
                    setTimeout(() => setDashUrlCopied(false), 2200);
                    onToast && onToast(`URL copiada: ${tenantUrl}`);
                  }}>
                    <Icon name="copy" size={14} />Copiar URL do dashboard
                  </button>
                  <button className="btn ghost" style={{ justifyContent: 'flex-start', gap: 10 }} onClick={() => setDashboardModal(false)}>
                    <Icon name="x" size={14} />Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })())}

      <ApiRepairConfirmModal
        open={!!apiRepairAction}
        action={apiRepairAction}
        tenant={repairTenant}
        onClose={() => { setApiRepairAction(null); setRepairTenant(null); }}
        onConfirm={() => { if (selectedTenant) loadHealth(selectedTenant); if (tab === 'historico') loadHistory(selectedTenant); }}
        onToast={onToast}
      />

      {!useRealApi && (
      <RepairConfirmModal
        open={!!repairModal}
        repair={repairModal}
        tenant={repairTenant}
        onClose={() => setRepairModal(null)}
        onConfirm={({ ok }) => onToast && onToast(ok ? 'Repair concluído' : 'Repair falhou — verifique os logs')}
        logAction={logAction}
      />
      )}

      <ExportDiagModal
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        onToast={onToast}
        logAction={logAction}
        contextTicket={contextTicket}
        selectedTenantName={currentTenant?.name || null}
      />

      <ReexecuteHistoryModal
        open={!!reexecuteItem} item={reexecuteItem} onClose={() => setReexecuteItem(null)}
        onConfirm={({ item, ok }) => {
          const ts = 'Hoje, ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
          setExtraHistory(h => [{ ts, tenant: item.tenant, repair: item.repair, by: 'Admin', result: ok ? 'success' : 'falha', duration: (1.2 + Math.random()).toFixed(1) + 's', reason: `Reexecução de: ${item.ts}`, changed: [] }, ...h]);
          onToast && onToast(ok ? `Repair reexecutado com sucesso` : 'Reexecução falhou — ver logs');
          logAction && logAction({ acao: `Repair reexecutado: ${item.repair}`, loja: item.tenant, kind: ok ? 'info' : 'danger' });
        }}
      />

      <PlaybookExecutionModal
        open={!!playbookItem} playbook={playbookItem} tenant={currentTenant} onClose={() => setPlaybookItem(null)}
        onConfirm={({ playbook }) => {
          const ts = 'Hoje, ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
          setExtraHistory(h => [{ ts, tenant: currentTenant?.name || '—', repair: `Playbook: ${playbook.symptom}`, by: 'Admin', result: 'success', duration: (playbook.steps?.length * 1.2).toFixed(1) + 's', reason: 'Execução de playbook', changed: [] }, ...h]);
          onToast && onToast(`Playbook “${playbook.symptom}” concluído`);
          logAction && logAction({ acao: `Playbook executado: ${playbook.symptom}`, loja: currentTenant?.name || '—', kind: 'info' });
        }}
      />
    </div>
  );
};

export {
  RepairConfirmModal,
  RepairsPage,
  RiskBadge,
};
